import Api from '@sancare/typescript-commons/src/misc/api'

import { state } from './state'

export const actions = {
  fetchStayActions({ commit }, stayId: number) {
    return Api.request(
      state.requests.fetchStayActions,
      {
        urlParams: { id: stayId },
        successMut: 'fetchStayActionsSuccess',
      },
      commit
    )
  },
  // No-op if already marked seen this session, so reopening the aside for the same stay
  // doesn't keep creating StayStatus rows backend-side.
  markStaySeen({ commit, rootState }, stayId: number) {
    if (state.seenStayIds.includes(stayId)) {
      return Promise.resolve()
    }

    return Api.request(
      state.requests.markStaySeen,
      {
        urlParams: { stayId },
        successMut: () => {
          commit('markStaySeenSuccess', stayId)
          commit('updateStayStatuses', { stayId, username: rootState.login.username }, { root: true })
        },
      },
      commit
    )
  },
}
